import React from "react";
import { Tooltip } from "@mui/material";

interface WarningBadgeProps {
  count: number;
  fontSize?: string;
}

const WarningBadge: React.FC<WarningBadgeProps> = ({ count, fontSize = "12px" }) => {
  if (!count || count <= 0) return null;

  return (
    <Tooltip title={`${count} Eintrag${count > 1 ? "e" : ""} außerhalb der Arbeitszeiten`}>
      <span
        style={{
          color: "#ff9800",
          fontWeight: "bold",
          fontSize,
          marginLeft: "6px",
          display: "inline-flex",
          alignItems: "center",
          gap: "2px",
        }}
      >
        ⚠️ {count}
      </span>
    </Tooltip>
  );
};

export default WarningBadge;
